import {Pipe, PipeTransform} from '@angular/core';
import {FormGroup} from '@angular/forms';

@Pipe({
    name: 'countEnabledFgItems'
})
export class CountEnabledFgItemsPipe implements PipeTransform {

    transform(formGroup: FormGroup, ...trigger: unknown[]): number {
        let count = 0;
        Object.keys(formGroup.value).forEach(key => {
            if (formGroup.value[key]) {
                count++;
            }
        });
        return count;
    }

}
